/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable react/forbid-elements */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
import Joi from '@hapi/joi';
import React from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { ITranslateProps, translate } from '../../mixins/translate';
import { ILanguageCodeProps, IValidationComponentState, ValidatingComponent } from '../../mixins/validation/validation';
import { check } from '../../store/authentication/actions';
import { fetchGet, fetchPost } from '../../store/fetch';
import { IConnectProps } from '../../utils/IConnectProps';
import { EditPanelCell, EditPanelInput, EditPanelRow, EditPanelSection } from '../elements';
import { ChangePassword } from './ChangePassword';
import { ChangeTwoFactorAuthentication } from './ChangeTwoFactorAuthentication';

interface IChangePersonalDataProps extends ITranslateProps, ILanguageCodeProps, IConnectProps {}

interface IChangePersonalDataState extends IValidationComponentState {
    message?: undefined | string;
    submitting: boolean;
    failed: boolean;
    saved: boolean;
    errorCode?: undefined | string;
    firstName?: undefined | string;
    lastName?: undefined | string;
    emailAddress?: undefined | string;
    mobileNumber?: undefined | string;
    officeNumber?: undefined | string;
    passwordAge?: undefined | number;
}

function mapStateToProps(state: any) {
    const { language } = state;
    return {
        languageCode: language.code,
    };
}

class ChangePersonalData extends ValidatingComponent<IChangePersonalDataProps, IChangePersonalDataState> {
    constructor(props: IChangePersonalDataProps) {
        super(props);
        this.state = {
            submitting: false,
            failed: false,
            saved: false,
            errors: {},
        };
    }

    public override componentDidMount() {
        void this.load();
    }

    public getValidatorData() {
        return {
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            emailAddress: this.state.emailAddress,
            mobileNumber: this.state.mobileNumber,
            officeNumber: this.state.officeNumber,
        };
    }

    public getValidatorTypes(): any {
        return {
            firstName: Joi.string().required().label(this.props.t('user.firstName')),
            lastName: Joi.string().required().label(this.props.t('user.lastName')),
            emailAddress: Joi.string().required().label(this.props.t('user.emailAddress')),
        };
    }

    public override render() {
        return (
            <div>
                <form method="post" action="/" id="profile-form">
                    <div className="panel-body bg-light">
                        {/* First & Last name*/}
                        <EditPanelRow>
                            <EditPanelCell rowCount={6}>
                                <EditPanelInput
                                    name="firstName"
                                    placeholder={this.props.t('user.firstName')}
                                    value={this.state.firstName}
                                    icon="fa fa-user"
                                    notValid={!this.isValid('firstName')}
                                    handleChange={this.handleChange.bind(this)}
                                    handleBlur={this.handleValidation.bind(this)}
                                />
                                {this.renderHelpText(this.getValidationMessages('firstName'))}
                            </EditPanelCell>
                            <EditPanelCell rowCount={6}>
                                <EditPanelInput
                                    name="lastName"
                                    placeholder={this.props.t('user.lastName')}
                                    value={this.state.lastName}
                                    icon="fa fa-user"
                                    notValid={!this.isValid('lastName')}
                                    handleChange={this.handleChange.bind(this)}
                                    handleBlur={this.handleValidation.bind(this)}
                                />
                                {this.renderHelpText(this.getValidationMessages('lastName'))}
                            </EditPanelCell>
                        </EditPanelRow>

                        {/* User e-mail*/}
                        <EditPanelSection>
                            <EditPanelInput
                                name="emailAddress"
                                placeholder={this.props.t('user.emailAddress')}
                                value={this.state.emailAddress}
                                icon="fa fa-user"
                                notValid={!this.isValid('emailAddress')}
                                handleChange={this.handleChange.bind(this)}
                                handleBlur={this.handleValidation.bind(this)}
                            />
                            {this.renderHelpText(this.getValidationMessages('lastName'))}
                        </EditPanelSection>

                        {/* Phone numbers */}
                        <EditPanelRow>
                            <EditPanelCell rowCount={6}>
                                <EditPanelInput
                                    name="mobileNumber"
                                    placeholder={this.props.t('user.mobileNumber')}
                                    value={this.state.mobileNumber}
                                    icon="fa fa-user"
                                    handleChange={this.handleChange.bind(this)}
                                    handleBlur={this.handleValidation.bind(this)}
                                />
                            </EditPanelCell>
                            <EditPanelCell rowCount={6}>
                                <EditPanelInput
                                    name="officeNumber"
                                    placeholder={this.props.t('user.officeNumber')}
                                    value={this.state.officeNumber}
                                    icon="fa fa-user"
                                    handleChange={this.handleChange.bind(this)}
                                    handleBlur={this.handleValidation.bind(this)}
                                />
                            </EditPanelCell>
                        </EditPanelRow>

                        {/* Password */}
                        <EditPanelSection>
                            <ChangePassword passwordAge={this.state.passwordAge} />
                        </EditPanelSection>

                        {/* 2FA */}
                        <EditPanelSection>
                            <ChangeTwoFactorAuthentication />
                        </EditPanelSection>
                    </div>
                    <div className="panel-footer text-right">
                        <button type="button" disabled={this.state.submitting} className="button btn-primary" onClick={() => this.saveClicked()}>
                            {' '}
                            {this.props.t('common.save')}{' '}
                        </button>
                    </div>
                </form>
            </div>
        );
    }

    private async load() {
        await this.setStatePromised({ submitting: true });
        const url = '/api/personalData';
        const result = await fetchGet(url);

        await this.setStatePromised(result.json);
        await this.setStatePromised({ submitting: false });
    }

    private saveClicked() {
        this.validate(async (validationError: any) => {
            if (!validationError) {
                await this.setStatePromised({ message: undefined, submitting: true, errorCode: undefined, failed: false });
                const data = this.getValidatorData() as any;
                const url = '/api/personalData';
                const result = await fetchPost(url, {}, data, ['EMAIL_NOT_UNIQUE', 'EMAIL_NOT_VALID']);
                if (result.errorCode === 'EMAIL_NOT_UNIQUE') {
                    await this.setStatePromised({ submitting: false, errorCode: result.errorCode, failed: true });
                    toast.error(this.props.t('user.errorEmailNotUnique'), { autoClose: 3000 });
                } else if (result.errorCode === 'EMAIL_NOT_VALID') {
                    await this.setStatePromised({ submitting: false, errorCode: result.errorCode, failed: true });
                    toast.error(this.props.t('user.errorEmailNotValid'), { autoClose: 3000 });
                } else {
                    await this.setStatePromised({ submitting: false, saved: true, failed: false });
                    toast.info(this.props.t('common.saved'), { autoClose: 3000 });
                    this.props.dispatch(check(false)); // TODO: ZXY-1109
                }
            }
        });
    }
}

// eslint-disable-next-line import/no-default-export
export default translate()(
    connect<IConnectProps, IChangePersonalDataProps, Record<string, unknown>>(mapStateToProps as any, undefined, undefined, { forwardRef: true })(
        ChangePersonalData as any,
    ) as any,
);
